import goArchive from './modules/goArchive';
import { resetInlineStyles } from './modules/tinyMce';
window.addEventListener('DOMContentLoaded', () => {
	goArchive();
	resetInlineStyles();
});
